import styled from "styled-components";

export const BoldClickHere = styled.strong`
  text-decoration: underline;
  cursor: pointer;
`;
